import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

export interface LayoutViewContextValue {
  sidebarWidth: number;
  expandedSidebarWidth: number;
  collapsedSidebarWidth: number;
  isSidebarCollapsed: boolean;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  viewportWidth: number;
  contentPaddingX: number;
  contentPaddingY: number;
}

const defaultViewportWidth = typeof window !== 'undefined' ? window.innerWidth : 1440;

const DEFAULT_LAYOUT_VIEW_CONTEXT: LayoutViewContextValue = {
  sidebarWidth: 0,
  expandedSidebarWidth: 280,
  collapsedSidebarWidth: 80,
  isSidebarCollapsed: false,
  isMobile: false,
  isTablet: false,
  isDesktop: true,
  viewportWidth: defaultViewportWidth,
  contentPaddingX: 24,
  contentPaddingY: 24,
};

export const LayoutViewContext = createContext<LayoutViewContextValue>(DEFAULT_LAYOUT_VIEW_CONTEXT);

export function LayoutViewProvider({
  value,
  children,
}: {
  value: LayoutViewContextValue;
  children: ReactNode;
}) {
  return <LayoutViewContext.Provider value={value}>{children}</LayoutViewContext.Provider>;
}

export function useLayoutViewContext(): LayoutViewContextValue {
  return useContext(LayoutViewContext);
}

